var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31783 3.97654C7.31783 3.84996 7.26754 3.72856 7.17804 3.63906C7.08853 3.54955 6.96713 3.49927 6.84055 3.49927C6.71397 3.49927 6.59258 3.54955 6.50307 3.63906C6.41357 3.72856 6.36328 3.84996 6.36328 3.97654V7.47654C6.36328 7.64836 6.45492 7.80618 6.60383 7.89081L8.8311 9.16354C8.94074 9.22279 9.0692 9.23681 9.18904 9.2026C9.30888 9.16839 9.41058 9.08866 9.47241 8.98046C9.53424 8.87225 9.5513 8.74416 9.51993 8.62354C9.48856 8.50293 9.41127 8.39937 9.30455 8.335L7.31783 7.19972V3.97654Z",
    fill: "#747B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.13409 0 0 3.13409 0 7C0 10.8659 3.13409 14 7 14C10.8659 14 14 10.8659 14 7C14 3.13409 10.8659 0 7 0ZM0.954545 7C0.954545 5.39665 1.59148 3.85896 2.72522 2.72522C3.85896 1.59148 5.39665 0.954545 7 0.954545C8.60335 0.954545 10.141 1.59148 11.2748 2.72522C12.4085 3.85896 13.0455 5.39665 13.0455 7C13.0455 8.60335 12.4085 10.141 11.2748 11.2748C10.141 12.4085 8.60335 13.0455 7 13.0455C5.39665 13.0455 3.85896 12.4085 2.72522 11.2748C1.59148 10.141 0.954545 8.60335 0.954545 7Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGrey);
export default __webpack_public_path__ + "static/media/clock-grey.64e6a0ffd57db0be7861b541358c802a.svg";
export { ForwardRef as ReactComponent };